import React, { useState } from "react";
import { PostDataAPI } from "../services/PostDataAPI";
import SuccessErrorDialog from "./successErrorDialog";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ReviewForm = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
    });
    const initialFormValues = {
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
    };


    const handleReset = () => {
        setFormData(initialFormValues);
    }
    const [message, setMessage] = useState(null);
    const [type, setType] = useState(null);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [resultDialog, setResultDialog] = useState(false);


    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const formatPhoneNumber = (value) => {
        const phone = value.replace(/\D/g, "").substring(0, 10);

        const size = phone.length;

        if (size < 4) return phone;
        if (size < 7) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;

        return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                name === "phone" ? formatPhoneNumber(value) : value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.fullName.trim()) {
            newErrors.fullName = "Full name is required.";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Contact number is required.";
        } else if (!/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(formData.phone)) {
            newErrors.phone = "Enter a valid phone number.";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Enter a valid email.";
        }

        if (!formData.injuryType) {
            newErrors.injuryType = "Please select an injury type.";
        }

        if (!formData.briefDescription.trim()) {
            newErrors.description = "Please enter a brief description.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        } else {
            setSubmitLoader(true);
            setErrors({});
            const formValues = { ...formData };

            try {
                setLoading(true);
                const result = await PostDataAPI("confidentailRequest/add", formValues);
                if (result.success) {
                    setMessage("Your request has been received. Thank you for reaching out. We will review your submission and get in touch with you shortly.");
                    setType("success");
                    setSubmitLoader(false);
                    //handleClose();
                    setTimeout(() => {
                        setResultDialog(true);
                        handleReset()
                    }, 100)
                    //showMessage("Success", result.message || "Meeting request submitted successfully.", "success", 3000);
                } else {
                    setSubmitLoader(false);
                    setMessage(result.message || "Failed to submit request.");
                    setType("error");
                    setResultDialog(true);
                }
            } catch (error) {
                setSubmitLoader(false);
                setMessage("Failed to submit request.");
                setType("error");
                setResultDialog(true);
                //if (error.name !== 'AbortError') {
                //showMessage("Failed to submit meeting request.", "error", 3000);
                //}
            } finally {
                setLoading(false);
                setSubmitLoader(false);
                //setRefreshCaptcha((prev) => !prev); // Trigger a refresh
            }
        }
    };


    return (
        <>
            <div className="hero-card">
                <div className="hero-card-label">Confidential</div>

                <h3>Request a Confidential Case Review</h3>
                <p>No upfront legal fees. Direct attorney attention.</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Full Name</label>
                        <input
                            type="text"
                            name="fullName"
                            placeholder="Your full name"
                            value={formData.fullName}
                            onChange={handleChange}
                        />
                        {errors.fullName && (
                            <small className="error">{errors.fullName}</small>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Contact Number</label>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="(XXX) XXX-XXXX"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                        {errors.phone && (
                            <small className="error">{errors.phone}</small>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="your@email.com"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && (
                            <small className="error">{errors.email}</small>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Select Injury Type</label>
                        <select
                            name="injuryType"
                            value={formData.injuryType}
                            onChange={handleChange}
                        >
                            <option value="">Choose one…</option>
                            <option>Personal Injury</option>
                            <option>Rear-End Collision</option>
                            <option>Car Accidents</option>
                            <option>Pedestrian Accident</option>
                            <option>Bicycle Accidents</option>
                            <option>Spinal Injury</option>
                            <option>Motorcycle Accident</option>
                            <option>Whiplash Injury</option>
                            <option>Drunk Driving</option>
                            <option>Truck Accident</option>
                            <option>Head-On Collision</option>
                        </select>

                        {errors.injuryType && (
                            <small className="error">{errors.injuryType}</small>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Brief Description</label>
                        <textarea
                            rows="3"
                            name="briefDescription"
                            placeholder="Briefly describe your situation…"
                            value={formData.briefDescription}
                            onChange={handleChange}
                        />

                        {errors.description && (
                            <small className="error">{errors.description}</small>
                        )}
                    </div>

                    <button type="submit" className="form-submit">
                        {submitLoader ? <FontAwesomeIcon
                            icon={faSpinner}
                            className="spinner-icon"
                            spin
                            style={{ fontSize: "20px", color: "#0f0f0e", marginRight: "10px" }}
                        /> : ''} Request Consultation
                    </button>


                </form>

                <div className="form-checks">
                    <div className="form-check-item"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></svg> No Upfront Fees</div>
                    <div className="form-check-item"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></svg> Confidential</div>
                    <div className="form-check-item"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></svg> Responsive Guidance</div>
                    <div className="form-check-item"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></svg> Focused Rep.</div>
                </div>
            </div>
            {resultDialog ?
                <SuccessErrorDialog type={type} message={message} open={resultDialog} handleClose={() => setResultDialog(false)} /> : null
            }
        </>
    );
};

export default ReviewForm;